import React from 'react';
import CrisisMap from '../map/map';
import LineChartTrends from '../lineChart/chart';

const RightPanel = () => {
  return (
    <div className="right-panel">
      <div style={{
        borderRadius: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#555',
        fontWeight: 'bold'
      }}>
        
        <CrisisMap/>
      </div>
      {/* <div style={{paddingBottom:"20px"}}>
        <LineChartTrends/>
      </div> */}
      
    </div>
  );
};

export default RightPanel;
